module.exports = __webpack_public_path__ + "img/t3.13b156f2.png";